<template>
  <div>
    <v-toolbar dense tile flat :elevation="1">
      <v-tabs v-model="tab" cols="12" :class="{'my-2': !dense }">
        <v-tab v-for="category in getCategories" :key="category.id">
          <v-badge
              :value="getItemsQuantityByCategory(category)"
              :color="category.fontColor"
              :content="getItemsQuantityByCategory(category)"
          >
            {{ category.name }}
          </v-badge>

        </v-tab>
      </v-tabs>
      <v-spacer></v-spacer>
      <v-text-field
          placeholder="buscar..."
          v-model="search"
          solo hide-details dense clearable
          class="mx-2"
      ></v-text-field>
      <gallery-view-buttons></gallery-view-buttons>
    </v-toolbar>

    <v-card  :loading="loading" outlined tile >
      <v-card-text v-if="!loading" class="pt-2 px-2" :style="{maxHeight: productCardHeight+'px',  overflowY: 'auto',}">
        <v-tabs-items v-model="tab">

          <v-tab-item v-for="category in getCategories" :key="category.id">
            <v-row dense>
              <v-col v-for="item in getProductsByCategory(category)"
                     :key="item.product.id"
                     cols="12" :sm="galleryView"
              >
                <bar-product-card
                    :product="item.product"
                    :category="category"
                    :order="item.order"
                    :quantity="$store.getters.orderSystem.cartService.getQuantityByProductAndCategory(item.product, category)"
                    :stock-quantity="item.quantity"
                    edit-quantity
                    :short-name="galleryView === 3"
                />

              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>

      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import StockProvider from "@/modules/delivery/providers/StockProvider";
import GalleryViewButtons from "@/modules/delivery/components-core/shared/GalleryViewButtons/GalleryViewButtons.vue";
import BarProductCard from "@/modules/delivery/components-core/business/BarProductCard/BarProductCard.vue";

export default {
  name: "BarProductGallery",
  components: {BarProductCard, GalleryViewButtons},
  props: {
    dense: {type: Boolean, default: false}
  },
  data() {
    return {
      stock: null,
      categories: [],
      filters: {
        name: null,
        ingredients: [],
        category: null
      },
      loading: false,
      tab: 0,
      search: ''
    }
  },
  created() {
    this.$store.dispatch('fetchCategories')
    this.checkBranch().then(() => this.fetchStockProducts())
  },
  computed: {
    windowHeight() {
      return window.innerHeight
    },
    productCardHeight() {
      return this.windowHeight ? this.windowHeight - 185 : 450
    },

    galleryView() {
      return this.$store.getters.galleryView
    },
    productItems() {
      return this.stock ? this.stock.items.filter(item => item.product) : []
    },
    getCategoriesMenu() {
      return this.$store.getters.getCategories.map(category => {
        return category.name
      })
    },
    getOrder() {
      return this.$store.getters.orderSystem.order
    },
    getOrderItems() {
      return this.$store.getters.orderSystem.order.items
    },
    getCategories() {
      if (this.filters.category) {
        return this.$store.getters.getCategories.filter(c => c.id === this.filters.category)
      }
      return this.$store.getters.getCategories
    },
    getProductsByCategory() {
      return category => {
        if (!this.search) {
          return this.productItems.filter(item => item.product.active && item.product.categories.some(c => c.id === category.id))
        } else {
          return this.productItems.filter(item => item.product.active && item.product.categories.some(c => c.id === category.id) && (item.product.name.toLowerCase().includes(this.search) || item.product.shortName.toLowerCase().includes(this.search)))
        }
      }
    },
    getItemsQuantityByCategory() {
      return category => {
        return this.$store.getters.orderSystem.cartService.getQuantityByCategory(category)
      }
    }
  },
  methods: {
    async checkBranch() {
      if (!this.branch) {
        await this.$store.dispatch('fetchDefaultBranch')
      }
      return this.branch
    },
    fetchStockProducts() {
      this.loading = true
      StockProvider.findStockByBranch(this.$store.getters.branchSelected.id)
          .then(r => {
            this.stock = r.data.findStockByBranch
          })
          .catch(e => {
            console.error(e)
          })
          .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped>

</style>
